/* eslint jsx-a11y/no-static-element-interactions: 0 */
/* eslint jsx-a11y/click-events-have-key-events: 0 */
/* eslint camelcase: 0 */
import { useState } from 'react';
import _, { round } from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import { Trans, t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { LegacyIcon } from '../../icon';
import Properties, { ROW_TYPES } from '../../properties/Properties';
import { FORMATTER_TYPES } from '../../../utilities/FormattingUtilities';
import { wirelessNetworkProperty, accessPointProperty, radioProperty } from '../../properties/components';
import { useFilterControl } from '../../page-framework/filter/FilterControl';

const useStyles = makeStyles((theme) => ({
    title: { cursor: 'move' },
    dialogIcon: {
        fontSize: 14,
        paddingRight: theme.spacing(2),
    },
    wifiSuccess: {
        '& span': {
            color: theme.palette.status.green,
            cursor: 'pointer',
        },
    },
    wifiFail: {
        '& span': {
            color: theme.palette.status.red,
            cursor: 'pointer',
        },
    },
}));

const DIALOG_ID = 'wireless-interface-icon-title';

function PaperComponent(props) {
    return (
        <Draggable handle={`#${DIALOG_ID}`} cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

const isPresent = (value) => !_.isNil(value) || !_.trim(value) === '';

function WirelessInterfaceIcon({ row }) {
    const filterControl = useFilterControl();
    const [dialogOpen, setDialogOpen] = useState(false);
    const classes = useStyles();

    function handleDialogOpen(event) {
        event.stopPropagation();
        filterControl.pauseAutoRefresh();
        setDialogOpen(true);
    }

    function handleDialogClose() {
        setDialogOpen(false);
        filterControl.resumeAutoRefresh();
    }

    function makeProperty(title, selector, formatter) {
        return {
            type: ROW_TYPES.TEXT,
            hasValue: (data) => isPresent(data[selector]),
            title: i18n._(title),
            selector,
            formatter,
        };
    }

    function formatChannelWidth(channelWidth) {
        return _.isNumber(channelWidth) && channelWidth > 0 ? `${channelWidth} MHz` : 'Unknown';
    }

    const wireLessClass = row?.wifi_connected ? classes.wifiSuccess : classes.wifiFail;

    const propertiesDef = {
        properties: [
            makeProperty(t`Vitals Date/Time`, 'testTime', FORMATTER_TYPES.DATETIME),
            wirelessNetworkProperty('wifi_connected', 'wifi_ssid'),
            makeProperty(t`Wi-Fi Errors`, 'wifi_connection_errors'),
            makeProperty(t`Wi-Fi Technology`, 'wifi_technology'),
            accessPointProperty('deviceName', 'deviceId'),
            radioProperty('radioName', 'radioId'),
            makeProperty(t`Wi-Fi BSSID`, 'wifi_bssid'),
            makeProperty(t`Wi-Fi IP`, 'wifi_ip_address'),
            makeProperty(t`Wi-Fi Signal Strength`, 'wifi_signal_level_dbm', (value) => `${value} dBm`),
            makeProperty(t`Wi-Fi Channel`, 'wifi_channel'),
            makeProperty(t`Wi-Fi Channel Width`, 'wifi_channel_width', formatChannelWidth),
            makeProperty(t`Wi-Fi Channel Frequency`, 'wifi_frequency', (value) => `${round(value, 3)}GHz`),
        ],
    };

    return (
        <>
            <div
                className={wireLessClass}
                title={i18n._(t`See Wi-Fi details when this test was run`)}
                onClick={handleDialogOpen}
            >
                <LegacyIcon icon="signal_wifi_4_bar" />
            </div>
            <Dialog open={dialogOpen} PaperComponent={PaperComponent} aria-labelledby={DIALOG_ID}>
                <DialogTitle className={classes.title} id={DIALOG_ID}>
                    {row?.agent?.name} <Trans>Wi-Fi Vitals</Trans>
                </DialogTitle>
                <DialogContent>
                    <Properties propertiesDef={propertiesDef} data={row} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>
                        <Trans>Close</Trans>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default WirelessInterfaceIcon;
